import { useRef, useState } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

export const NAV_LINKS = [
  { id: "products", label: "Products" },
  { id: "about", label: "About" },
  { id: "careers", label: "Careers" },
  { id: "investors", label: "Investors" },
  { id: "contact", label: "Contact" },
];

export const Brand = ({ testId = "nav-brand-logo", sub = true }) => (
  <a href="#top" className="brand" data-testid={testId} aria-label="Sentinel Nexus Technologies, back to top">
    <span className="brandmark" aria-hidden="true"><i /><i className="r2" /><b>SNT</b></span>
    <span className="brand-lockup">
      <span className="brand-main"><strong>SENTINEL</strong><em>NEXUS</em></span>
      {sub && <span className="brand-sub">TECHNOLOGIES // INTELLIGENCE SYSTEMS</span>}
    </span>
  </a>
);

const MobileNav = ({ onCta }) => {
  const [open, setOpen] = useState(false);
  const pending = useRef(null);
  const go = (e, id, cta) => {
    e.preventDefault();
    if (cta) onCta(cta);
    pending.current = id;
    setOpen(false);
  };
  const afterClose = (e) => {
    if (!pending.current) return;
    e.preventDefault();
    const id = pending.current;
    pending.current = null;
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView();
      window.history.replaceState(null, "", `#${id}`);
    }, 0);
  };
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button type="button" className="icon-btn ml-auto nav:hidden" aria-label="Open menu" data-testid="mobile-menu-toggle">
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" onCloseAutoFocus={afterClose} className="mobile-drawer" data-testid="mobile-nav-drawer">
        <SheetTitle className="kicker">Menu</SheetTitle>
        <nav aria-label="Mobile" className="mt-10 flex flex-col gap-1">
          {NAV_LINKS.map((l) => (
            <a key={l.id} href={`#${l.id}`} onClick={(e) => go(e, l.id)} className="drawer-link" data-testid={`mobile-nav-link-${l.id}`}>
              {l.label}
            </a>
          ))}
          <a href="#contact" onClick={(e) => go(e, "contact", "mobile-nav-briefing")} className="btn btn-strong mt-8 justify-center" data-testid="mobile-nav-briefing-cta">
            Request a briefing
          </a>
        </nav>
      </SheetContent>
    </Sheet>
  );
};

export const SiteHeader = ({ onCta }) => (
  <header className="site-nav">
    <Brand />
    <nav aria-label="Primary" className="navlinks hidden nav:flex">
      {NAV_LINKS.map((l) => (
        <a key={l.id} href={`#${l.id}`} data-testid={`nav-link-${l.id}`}>{l.label}</a>
      ))}
    </nav>
    <a href="#contact" onClick={() => onCta("nav-briefing")} className="btn hidden lg:inline-flex" data-testid="nav-briefing-cta">
      Request a briefing
    </a>
    <MobileNav onCta={onCta} />
  </header>
);
